module.exports = __webpack_public_path__ + "img/day8.2b186f63.svg";